// extracted by mini-css-extract-plugin
export default {"box":"Exam_box__Jf8Xp","title":"Exam_title__HQ02S"};